import { Injectable } from "@angular/core";
import { CatalogPaginationRequest } from "../../shared/models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../shared/models/Filter/FilterRequest";
import { AlarmAPIService } from "../../shared/services/API/AlarmAPI.service";

@Injectable({
  providedIn: "root",
})
export class SystemAlarmService {
  
  constructor(private alarmService: AlarmAPIService) {
  }

  alarmSystemFilter: FilterRequest = {key: "AlarmCategory", value: "Sistema"}

  //paginacion, hay un push que es sólo para el caso de las alarmas de sistema
  getFilterValues(request : FilterRequest[]) {
    request.push(this.alarmSystemFilter);
    return this.alarmService.getFilterValues(request);
  }

  getPage(request : CatalogPaginationRequest) {
    request.filters.push(this.alarmSystemFilter);
    return this.alarmService.getPage(request);
  }
  getCount(request : CatalogPaginationRequest) {
    request.filters.push(this.alarmSystemFilter);
    return this.alarmService.getCount(request);
  }

  //porque este catalogo tiene la opción de borrar, se debe agregar el borrado
  delete(idAlarm){
    return this.alarmService.delete(idAlarm);
  }
  
}
